import { render, staticRenderFns } from "./RPageHeader.vue?vue&type=template&id=83068f56&scoped=true&"
import script from "./RPageHeader.vue?vue&type=script&lang=js&"
export * from "./RPageHeader.vue?vue&type=script&lang=js&"
import style0 from "./RPageHeader.vue?vue&type=style&index=0&id=83068f56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83068f56",
  null
  
)

export default component.exports